// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import CreateAlertExpirationSelectorTemplate from '@front/templates/CreateAlertExpirationSelectorTemplate.html';
import { ContainerControl } from '../../elements/ContainerControl';
import { Resources } from '@shared/localizations/Resources';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
export class CreateAlertExpirationSelector extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return 'CreateAlertExpirationSelector';
    }
    oninit() {
        super.oninit();
        this.repopulate();
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
    }
    repopulate() {
        const DataTime = new Date();
        DataTime.setHours(23);
        DataTime.setMinutes(59);
        DataTime.setSeconds(0);
        DataTime.setDate(DataTime.getDate() + 30);
        void this.set('expirationTime', DataTime);
    }
    dispose() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.dispose();
    }
    localize() {
        void this.set({
            label: Resources.getResource('screen.Alerts.Label.Expiration'),
            infoBtnTooltip: Resources.getResource('screen.Alerts.Label.Expiration.InfoTooltip')
        });
    }
}
ContainerControl.extendWith(CreateAlertExpirationSelector, {
    template: CreateAlertExpirationSelectorTemplate,
    data: function () {
        return {
            label: '',
            btnTooltip: '',
            visibleInfoBtn: true,
            expirationTime: null,
            width: 177,
            datePickerButtons: []
        };
    }
});
